<template>
    <el-form
        v-if="isInit"
        class="img-item"
        ref="form"
        :model="field"
        :label-width="field.name ? '120px' : '0'"
    >
        <el-form-item
            class="input-row"
            prop="def_val.items"
            :rules="fieldRules"
        >
            <div
                v-if="field.name"
                slot="label"
                class="label-item common"
            >
                <p class="label-text">{{ field.desc }}</p>
                <el-tooltip
                    class="item"
                    effect="light"
                    placement="bottom-start"
                >
                    <div slot="content">
                        - 描述: <strong>{{ field.desc }}</strong><br />
                        - name: <strong>{{ field.name }}</strong><br />
                    </div>
                    <i class="label-icon el-icon-info"></i>
                </el-tooltip>
            </div>
            <div class="checkbox-wrap">
                <div class="search-wrap">
                    <span class="search-label">类型：</span>
                    <el-input
                        class="search-input"
                        v-model="field.def_val.search_type"
                        placeholder="输入类型，搜索出该类型的列表项目"
                    >
                        <!-- <i
                            class="el-icon-search el-input__icon"
                            slot="suffix">
                        </i> -->
                    </el-input>
                </div>
                <div class="search-wrap">
                    <span class="search-label">域名：</span>
                    <el-select
                        class="search-input"
                        v-model="field.def_val.host"
                        placeholder="选择域名，自动替换列表项目的图片链接上"
                        clearable
                        filterable
                    >
                        <el-option
                            v-for="item in hostOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="search-wrap">
                    <span class="search-label">渠道：</span>
                    <el-input
                        class="search-input"
                        v-model="field.def_val.channel"
                        placeholder="输入渠道，自动绑定到列表项目的链接上"
                    >
                    </el-input>
                </div>
                <p class="label-title">待选：</p>
                <el-checkbox-group
                    v-model="field.def_val.items"
                    @change="imgItemsCheckHandler"
                >
                    <el-checkbox
                        v-for="(item) in typeImgItemsByType"
                        :label="item._id"
                        :key="item._id"
                    >
                        {{ item.title }}
                    </el-checkbox>
                </el-checkbox-group>
                <p class="label-title">已选<span class="tips">(拖动图块调整顺序)</span>：</p>
                <div>
                    <draggable
                        :list="field.def_val.items"
                        class="images-drag-area"
                        v-if="field.def_val.items.length"
                    >
                        <div
                            v-for="(item, index) in checkedImgItems"
                            :key="index"
                            class="drag-item"
                            title="拖动图块调整顺序"
                        >
                            <img
                                class="thumb-pic"
                                :src="item.img_url"
                            />
                            <a
                                class="thumb-title"
                                :href="item.link"
                                target="_blank"
                            >{{ item.title }}</a>
                            <i
                                class="el-icon-delete del-btn"
                                title="点击删除"
                                @click="imagesDel(index)"
                            />
                        </div>
                    </draggable>
                    <div
                        class="no-data"
                        v-if="!field.def_val.items.length"
                    >暂无数据</div>
                </div>
            </div>
        </el-form-item>
    </el-form>
</template>
<script>
import moment from "moment";
import apiPath from "@/service/apiPath.js";
import { requestApi } from "@/service/requestApi.js";
import draggable from "vuedraggable";

export default {
    name: "img-item",
    props: ["field", "autoInit"],
    data() {
        return {
            // resField: this.field,
            fieldRules: {
                required: this.field.require,
                message: `请选择'${this.field.desc}'的项目`,
                trigger: "change",
            },
            imgItems: [],
            isInit: this.autoInit,
            hostOptions: [
                {
                    value: "img-oss.gznxl11.com",
                    label: "img-oss.gznxl11.com",
                },
                {
                    value: "img-oss.shunliwenhua1.com",
                    label: "img-oss.shunliwenhua1.com",
                },
                {
                    value: "img-oss.shunliwh66.com",
                    label: "img-oss.shunliwh66.com",
                },
                {
                    value: "img-oss.suanfa666.com",
                    label: "img-oss.suanfa666.com",
                },
                {
                    value: "img-fe.zwe1li8.com",
                    label: "img-fe.zwe1li8.com",
                },
                {
                    value: "img-fe.tengzhihh.com",
                    label: "img-fe.tengzhihh.com",
                },
                {
                    value: "img-fe.orpseon.cn",
                    label: "img-fe.orpseon.cn",
                },
                {
                    value: "img-cdn.tengzhihh.com",
                    label: "img-cdn.tengzhihh.com",
                },
                {
                    value: "cdn.shunliwenhua5.com",
                    label: "cdn.shunliwenhua5.com",
                },
            ],
        };
    },
    computed: {
        typeImgItemsByType() {
            let searchType = this.field.def_val.search_type;
            let tmpArr = searchType
                ? _.filter(
                      this.imgItems,
                      (v) => v.type === this.field.def_val.search_type
                  )
                : this.imgItems;
            return tmpArr;
        },
        checkedImgItems() {
            let tmpArr = _.map(this.field.def_val.items, (item) => {
                let tmpObj = {};
                let lastIndex = _.findLastIndex(
                    this.imgItems,
                    (v) => v._id === item
                );
                if (lastIndex !== -1) {
                    tmpObj = this.imgItems[lastIndex];
                }
                return tmpObj;
            });
            return tmpArr;
        },
    },
    components: {
        draggable,
    },
    watch: {},
    methods: {
        initData() {
            this.isInit = true;
            this.remoteImgItemsHandler();
        },
        fieldBeReady() {
            // 确认组件是否就绪
            return this.$refs["form"];
        },
        getResField() {
            let isValidate = false;
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    isValidate = true;
                } else {
                    isValidate = false;
                }
            });
            if (!isValidate) {
                return;
            }
            return this.field;
        },
        remoteImgItemsHandler() {
            let defaultQuery = {
                per_page: 1000,
                current: 1,
            };
            this.loading = true;
            requestApi({
                method: "get",
                url: apiPath.HANDLER_IMG_ITEM,
                options: {
                    params: defaultQuery,
                },
                successFn: (data) => {
                    if (data.hasOwnProperty("list")) {
                        this.imgItems = data.list;
                    }
                },
            }).then(() => {
                this.loading = false;
            });
        },
        imagesDel(index) {
            // this.$confirm('此操作将删除该项，是否继续？', '提示', {
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            // }).then(() => {
            //     this.field.def_val.items.splice(index, 1);
            // }).catch((e) => {
            // });
            this.field.def_val.items.splice(index, 1);
        },
        imgItemsCheckHandler() {},
    },
    mounted() {},
};
</script>
<style lang="less">
@import (reference) "../../styles/public.less";
.img-item {
    .label-item();
    .select-input {
        width: 100%;
    }
    .checkbox-wrap {
        margin-left: 5px;
        background-color: #ddd;
        padding: 5px 10px;
        border-radius: 5px;
        .label-title {
            font-size: 14px;
            font-weight: 600;
            color: #333;
            line-height: 36px;
            display: block;
            .tips {
                color: #606266;
                font-weight: 500;
            }
        }
        .el-checkbox {
            margin: 0 30px 0 0;
        }
        .search-wrap {
            margin-bottom: 5px;
            .search-label {
                font-size: 14px;
                font-weight: 600;
                color: #333;
            }
            .search-input {
                display: inline-block;
                width: 50%;
            }
        }
    }
    .images-drag-area {
        display: inline-block;
    }
    .drag-item {
        width: 150px;
        height: 150px;
        display: inline-block;
        vertical-align: top;
        padding: 5px;
        border: dashed 1px #fff;
        border-radius: 5px;
        margin: 0 10px 10px;
        line-height: 150px;
        text-align: center;
        position: relative;
        transition: 0.3s;
        .thumb-pic {
            display: inline-block;
            max-width: 100%;
            max-height: 100%;
            transition: 0.3s;
        }
        .thumb-title {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            background-color: rgba(255, 255, 255, 0.8);
            height: 30px;
            line-height: 30px;
            font-size: 13px;
            color: #20a0ff;
            text-align: center;
        }
        .del-btn,
        .preview-btn,
        .reupload-btn {
            position: absolute;
            top: 10px;
            right: 10px;
            opacity: 0.2;
            cursor: pointer;
            color: red;
            font-size: 16px;
            transition: 0.1s;
        }
        &:hover {
            border-color: #20a0ff;
            .thumb-pic {
                opacity: 0.2;
            }
            .del-btn {
                opacity: 1;
            }
        }
        // &.sortable-chosen {
        //     transform: rotateZ(-10deg);
        // }
    }
    .no-data {
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/compEditForm/imgItem.vue